<template>
  <div
    class="edit-station edit-station-parameters"
  >
    <div class="edit-station-parameters__column">
      <input-element
        class="edit-program__top-bar__name"
        :name="'Name'"
        :title="'Name'"
        :prefix="station.decid"
        :text="station.name"
        :placeholder="$t('messages.sharedTexts.placeholders.nameMaxChars', {length: 8})"
        :emit-function-named="'setStationName'"
        :max-length="8"
        @setStationName="setStationName"
      />
      <input-element
        class="edit-program__top-bar__name"
        :name="'Description'"
        :title="'Description'"
        :text="station.description"
        :max-length="25"
        :placeholder="'Description'"
        :emit-function-named="'setStationDescription'"
        @setStationDescription="setStationDescription"
      />
      
      <div>
        <input-element
          class="edit-program__top-bar__name"
          :name="'Address'"
          :title="'Address'"
          :text="station.address"
          :placeholder="`Station Address`"
          :emit-function-named="'setStationAddress'"
          @setStationAddress="setStationAddress"
        />
      </div>
    </div>
    <div class="edit-station-parameters__column">
      <div 
        class="div_grouping"
      >
        <input-element
          class="edit-program__top-bar__name"
          :name="'Expected Flow'"
          :title="'Expected Flow'"
          :min="0"
          :max="unitsInMetric() ? 3786: 999" 
          :step="1"
          :type="'number'"
          :text="convertUnits(station.expectedFlow, 'gal/min', 'l/min').toFixed(0)"
          :placeholder="'Expected Flow'"
          :emit-function-named="'setStationExpectedFlow'"
          style="width: 75%; display: inline-block"
          @setStationExpectedFlow="setStationExpectedFlow"
        />
        <div 
          padding:0px
          margin:0px
          style="width: 25%; display: inline-block; text-align: left"
        >
          &nbsp;&nbsp;{{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
        </div>
      </div>
      <input-element
        class="edit-program__top-bar__name"
        :name="'Acres'"
        :title="'Acres'"
        :text="station.acres"
        :placeholder="'Acres'"
        :emit-function-named="'setStationExpectedFlow'"
        @setStationAcres="setStationAcres"
      />
    </div>
    <div class="edit-station-parameters__column">
      <!-- <h4
        class="g-title g-title--subtitle"
      >
        {{ station.status === '1' ? 'Station Blocked' : 'Block Station' }}
      </h4>
      <div
        class="edit-station-parameters__toggle"
        :class="{'active': station.status === '1'}"
      >
        <div
          class="g-btn g-btn--rounded g-btn--toggle"
          type="button"
          name="button"
          @click="stationBlockToggleClick"
        />
      </div>
      <div>
        <h4
          class="g-title g-title--subtitle"
        >
          <strong>{{ computedBlockedText }}</strong>
        </h4>
        <p>
          When a station is blocked, it remains part of a program setup but it is skipped during watering.
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import{SocketHandler, LifeCycle, MicroService, UnitSystem} from'@/assets/javascript/mixins/Mixins'
import {lowerCaseObject} from '@/assets/javascript/utilities'
import InputElement from'@/components/elements/InputElement.vue'

export default {
  name: 'EditStationParameters',
  components: {
    'input-element': InputElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService, UnitSystem],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    station: {
      type: Object,
      default: function() {
        return {}
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    computedExpectedFlow() {
      return this.station.expectedFlow
    },
    computedBlockedText() {
      return this.station.status === '1' ? 'This station is blocked.' : 'This station is active.'
    }
  },
  methods: {
    updateStation(fields) {
      this.SocketMessageSend(
        Object.assign({}, {
          Category: 'Stations',
          Type: 'StationData',
          Oper: 'Upd',
          Seq: this.station.decId
        },
        lowerCaseObject(fields))
      )

      Object.keys(fields).forEach(key=> this.$set(this.station, key, '' +  fields[key])) // @TODO: Should be done with return data when ready
    },
    setStationName(val) { 
      this.updateStation({name: val})
    },
    setStationDescription(val) { 
      this.updateStation({description: val})
    },
    setStationExpectedFlow(val) {
      this.updateStation({expectedFlow: this.convertUnits(parseInt(val), 'l/min', 'gal/min')})
    },
    stationBlockToggleClick() {
      this.station.status = this.station.status === '0' ? '1' : '0'
      this.updateStation({status: parseInt(this.station.status)})
    },

    setStationAddress(val) { 
      this.updateStation({address: val})
    },
    setStationAcres(val) { 
      this.updateStation({acres: val})
    }
  }
}
</script>
